module.exports = __webpack_public_path__ + "static/media/guide_Page_23.6aca02e0.png";